module.exports = __webpack_public_path__ + "static/media/eyal.52be8223.png";